import React, { useEffect } from 'react';
import { debouncedRebuildReactTooltip } from '../../debouncedRebuildReactTooltip';
import { ICellRendererParamsWithData } from '../types';


export function addTooltipToCellRenderer<T extends Record<string, unknown>>(
  CellRenderer: React.FC<any>,
  getTooltipText?: (data: ICellRendererParamsWithData<T>) => string | null
) {
  function WithTooltipCellRendererWrapper(props: ICellRendererParamsWithData<T>) {
    useEffect(() => {
      debouncedRebuildReactTooltip();
    }, []);

    const tooltipText = getTooltipText?.(props) ?? '';

    if (tooltipText) {
      return (
        <div data-tip={tooltipText}>
          <CellRenderer {...props}/>
        </div>
      );
    }

    return <CellRenderer {...props}/>;
  }

  return WithTooltipCellRendererWrapper;
}
